import { useState } from "react";
import { useImpersonation } from "../hooks/useImpersonation.jsx";

function formatName(session) {
  if (!session) return "";
  const parts = [session.firstName, session.lastName].filter(Boolean);
  if (parts.length) return parts.join(" ");
  if (session.email) return session.email;
  if (session.userId) return `User ${session.userId}`;
  return "Unknown user";
}

export default function ImpersonationBanner() {
  const { impersonating, session, stopImpersonation, updating } = useImpersonation();
  const [stopping, setStopping] = useState(false);

  if (!impersonating || !session) {
    return null;
  }

  const handleStop = async () => {
    if (stopping || updating) return;
    setStopping(true);
    try {
      await stopImpersonation();
    } catch (err) {
      console.error("Failed to stop impersonation", err);
    } finally {
      setStopping(false);
    }
  };

  return (
    <div className="impersonation-banner" role="status" aria-live="polite">
      <div className="impersonation-banner__info">
        <strong>Impersonating</strong>
        <span>{formatName(session)}</span>
        {session.email && !session.email.includes(formatName(session)) ? (
          <span className="impersonation-banner__email">({session.email})</span>
        ) : null}
        {session.tenantSlug || session.tenantName ? (
          <span className="impersonation-banner__tenant">
            Tenant: {session.tenantName || session.tenantSlug}
          </span>
        ) : null}
        {session.expiresAt ? <span>Expires {new Date(session.expiresAt).toLocaleString()}</span> : null}
        {session.impersonatedBy ? <span>Started by #{session.impersonatedBy}</span> : null}
      </div>
      <button
        type="button"
        className="impersonation-banner__stop"
        onClick={handleStop}
        disabled={stopping || updating}
      >
        {stopping || updating ? "Stopping…" : "Stop"}
      </button>
    </div>
  );
}
